module.exports = __webpack_public_path__ + "img/drugThirdFiling.ae188cd1.png";